import type { Feature } from '@luna/gatekeeper';

export const cardLimitsFocusPage: Feature = {
    enabled: true,
    _description: 'Displays the newly refactored Card Limits focus page which replaces the modal',
};
